import {cloneDeep} from 'lodash'
export const getUserTypeForAnalytics = () => {
  const userEmail = sessionStorage.getItem('userEmail')
  if (userEmail) {
    return userEmail.split('@')[1].split('.')[0] === 'deloitte' ? 'internal' : 'external'
  }
  return ''
}

const actionInfoTemplate = {
  state: {
    name: ''
  },
  // Ruleset:hp_apply_filter
  filter: {
    name: '',
    category: '',
    subCategory: ''
  }, // Ruleset:hp_export
  export: {
    type: '',
    fileType: '',
    source: ''
  },
  // Ruleset:hp_dashboard
  dashboard: {
    button: {
      name: ''
    }
  },
  // Ruleset:hp_usecase
  usecase: {
    name: '',
    domain: '',
    topic: '',
    subTopic: ''
  },
  // Ruleset:hp_persona_toggle
  personaToggle: '',
  // Ruleset:hp_persona
  persona: {
    name: '',
    section: ''
  },
  // Ruleset:hp_mapview
  preferredMapView: '',
  // Ruleset:hp_chatbot
  chatbot: {
    button: {
      name: ''
    }
  },
  // Ruleset:hp_error
  error: {
    source: '',
    type: ''
  }
}
const digitalData = {
  user: {
    userEmail: '',
    userType: '',
    // New Additions
    userRole: '',
    projectId: '',
    projectName: '',
    clientId: '',
    clientName: '',
    // specific to user feedback events
    eventName: '',
    eventParticipantName: '',
    eventParticipantJob: ''
  },
  page: {
    pageInfo: {
      pageName: '',
      siteSection: ''
    }
  },
  action: {
    actionInfo: actionInfoTemplate
  }
}

globalThis.digitalData = digitalData

const Analytics = {
  digitalData
}

const setAdobeDigialData = (params) => {
  digitalData.action.actionInfo = params
}
const resetData = () => {
  // Reset action info
  digitalData.action.actionInfo = cloneDeep(actionInfoTemplate)

  // Update user data from session storage to ensure latest values
  const keys = [
    'userEmail',
    'projectId',
    'projectName',
    'clientId',
    'clientName',
    'userRole',
    'eventName',
    'eventParticipantName',
    'eventParticipantJob'
  ]
  for (const key of keys) {
    digitalData.user[key] = sessionStorage.getItem(key) || ''
  }
  digitalData.user.userType = getUserTypeForAnalytics()
}

export {Analytics, resetData, setAdobeDigialData}
